import '../../assets/scss/splash.scss'
import util from '../../common/js/util'
import common from '../../common/js/common'
import {getAppFlyerRoute, replaceAppFlyerHost, sendAdtracking} from '../../lib/public'

window.util = util;
window.common = common;

if (module.hot) {
  module.hot.accept()
}

let app;
let mainCampaign;
window.app = app
window.mainCampaign = mainCampaign

class App {
  constructor (props) {
    // 预留
  }

  /**
   * 设定跳转链接
   * alecfc = 1 或 不存在时，全局可点
   * */
  insertNoticeUrl () {
    const me = this;
    const alecfc = util.getUrlParams('alecfc');
    if (alecfc !== '' && parseInt(alecfc) !== 1) {
      (document.getElementsByClassName('bg'))[0].className = 'bg';
    }
    let noticeArr = document.getElementsByClassName("notice_url");
    for (let i of noticeArr) {
      i.addEventListener('click', me.install);
    }
  }

  /**
   * 设置背景
   *  */
  setBackground () {
    const bgContainer = document.getElementsByClassName('bg')[0];
    let heightFromCamp = parseInt(util.device().isiOS ? mainCampaign.device.device_height : mainCampaign.device.screen_height, 10);

    // 安卓SDK返回的px，IOS是pt
    if (util.device().isAndroid) {
      heightFromCamp /= window.devicePixelRatio;
    }

    const height = heightFromCamp
      || window.innerHeight
      || document.documentElement.clientHeight
      || document.body.clientHeight;
    bgContainer.setAttribute('style', `background: url(${mainCampaign.campaignList[0].image_url_localPath}) no-repeat; background-size: 100% 100%; height: ${height}px;`);
  }

  /**
   * @description 由物理像素获取CSS像素
   * @param {String} sWidth 屏幕宽
   * @param {String} sHeight 屏幕高
   */
  getCssPixel (sWidth, sHeight) {
    let width = parseInt(sWidth, 10);
    let height = parseInt(sHeight, 10);

    // 安卓SDK返回的px，IOS是pt
    if (util.device().isAndroid) {
      width /= window.devicePixelRatio;
      height /= window.devicePixelRatio;
    }
    return {width, height};
  }

  /**
   * 主体内容（视频或图片）自适应
   * case 1 : 等比放大直至顶天立地或者左右碰壁
   * case 2 : 等比缩小直至能显示完全
   *  */
  mainContentAdaptingAndDisplay () {
    const mainContent = (document.getElementsByClassName('main'))[0];
    let width, height;
    let ret;
    if (util.device().isiOS) {
      ret = this.getCssPixel(mainCampaign.device.device_width, mainCampaign.device.device_height);
    } else {
      ret = this.getCssPixel(mainCampaign.device.screen_width, mainCampaign.device.screen_height);
    }

    width = ret.width;
    height = ret.height;

    // 是开屏视频吗？
    const isVideo = util.getUrlParams('video') ? util.getUrlParams('video') : 0;
    const mainCampaignInfo = mainCampaign.campaignList[0];

    if (isVideo != '1') {
      const imgEle = document.createElement('img');
      imgEle.setAttribute('src', mainCampaignInfo.image_url_localPath);
      imgEle.onload = function () {
        // 如果图片过小则不显示
        if (imgEle.width >= 640 || imgEle.height >= 960) {
          const hScale = imgEle.height / height;
          const wScale = imgEle.width / width;
          let flag = 1;
          if (hScale <= 1 && wScale <= 1) {
            flag = 0;
          }

          if (flag) {
            if (hScale >= wScale)
              mainContent.setAttribute('style', `height: ${height}px; width: ${imgEle.width / hScale}px;`);
            else
              mainContent.setAttribute('style', `height: ${imgEle.height / wScale}px; width: ${width}px;`);
          } else {
            if (hScale < wScale)
              mainContent.setAttribute('style', `height: ${imgEle.height / wScale}px; width: ${width}px;`);
            else
              mainContent.setAttribute('style', `height: ${height}px; width: ${imgEle.width / hScale}px;`);
          }
          imgEle.setAttribute('class', 'adImage');
        } else {
          common.handlerH5ExceptionForSplash(-1000, 'The image is too small !');
        }
      };
      mainContent.insertAdjacentElement('afterbegin', imgEle);
    } else {
      mainCampaignInfo.video_resolution = '960x540';
      // mainCampaignInfo.video_url = 'https://interactive-examples.mdn.mozilla.net/media/examples/flower.webm';
      const sourceSize = mainCampaignInfo.video_resolution;
      const sourceHeight = parseInt(sourceSize.split('x')[1], 10);
      const sourceWidth = parseInt(sourceSize.split('x')[0], 10);
      const hScale = sourceHeight / height;
      const wScale = sourceWidth / width;
      let flag = 1;
      if (hScale <= 1 && wScale <= 1) {
        flag = 0;
      }

      const videoEle = document.createElement('video');
      videoEle.setAttribute('class', 'adVideo');
      videoEle.setAttribute('src', mainCampaignInfo.video_url_localPath);
      if (mainCampaign && mainCampaign.sdkSetting && mainCampaign.sdkSetting.playVideoMute == '1') {
        videoEle.muted = true;
      }
      if (flag) {
        if (hScale >= wScale)
          mainContent.setAttribute('style', `height: ${height}px; width: ${sourceWidth / hScale}px;`);
        else
          mainContent.setAttribute('style', `height: ${sourceHeight / wScale}px; width: ${width}px;`);
      } else {
        if (hScale < wScale)
          mainContent.setAttribute('style', `height: ${sourceHeight / wScale}px; width: ${width}px;`);
        else
          mainContent.setAttribute('style', `height: ${height}px; width: ${sourceWidth / hScale}px;`);
      }
      mainContent.insertAdjacentElement('afterbegin', videoEle);
    }
  }

  /**
   * 根据类名播放找到的第一个视频
   * @description 如果找不到则不执行任何操作
   * @param {String} className 视频标签元素的类名
   */
  playFirstAdVideoByClassName (className) {
    const videoEles = document.getElementsByClassName(className);
    if (videoEles.length > 0) {
      videoEles[0].play();
    }
  }

  /**
   * 根据类名播放找到的第一个视频
   * @description 如果找不到则不执行任何操作
   * @param {String} className 视频标签元素的类名
   */
  pauseFirstAdVideoByClassName (className) {
    const videoEles = document.getElementsByClassName(className);
    if (videoEles.length > 0) {
      videoEles[0].pause();
    }
  }

  /**
   * 获取关闭按钮内文字
   * @param {String} secondRemain 显示的剩余秒数
   * @param {Number} skip 允许跳过与否的标志
   */
  getCloseBtnText (secondRemain, skip) {
    let retText = '';
    if (skip == 1) {
      switch (navigator.language.toLowerCase()) {
        case 'zh':
        case 'zh-cn':
          retText = `点击跳过 | ${secondRemain}s`;
          break;
        case 'zh-hk':
        case 'zh-tw':
          retText = `點擊跳過 | ${secondRemain}s`;
          break;
        default:
          retText = `SKIP ${secondRemain}s`;
      }
    } else {
      switch (navigator.language.toLowerCase()) {
        case 'zh':
        case 'zh-cn':
          retText = `${secondRemain}s 后自动关闭`;
          break;
        case 'zh-hk':
        case 'zh-tw':
          retText = `${secondRemain}s 後自動關閉`;
          break;
        default:
          retText = `Auto close after ${secondRemain}s`;
      }
    }
    return retText;
  }

  /**
   * 设置H5关闭按钮宽度
   * @description 浏览器语言为中文，按钮为中等长度，为英文，SKIP时为短，不能跳过时变长
   * @param {Number} skip 跳过标志
   * @param {documentElement} btnEle H5关闭按钮
   */
  setCloseBtnWidth (skip, btnEle) {
    switch (navigator.language.toLowerCase()) {
      case 'zh':
      case 'zh-cn':
      case 'zh-hk':
      case 'zh-tw':
        btnEle.style.width = '25%';
        break;
      default:
        btnEle.style.width = skip == 1 ? '15%' : '30%';
    }
  }

  /**
   * 显示关闭按钮
   * @param {Number} needH5Btn 默认为0，设为1时显示h5关闭按钮
   * @param {Number} skip 默认为1，允许跳过。
   * @param {Number} countdown 等待时间默认为5，单位：秒
   */
  toggleCloseBtn (needH5Btn = '0', skip = 1, countdown = 5) {
    const me = this;
    if (needH5Btn == '1') {
      // 隐藏SDK关闭按钮
      common.toggleCloseBtnForSplash(2);

      // 开始渲染H5关闭按钮
      const bg = (document.getElementsByClassName('bg'))[0];
      const btn = document.createElement('div');
      btn.setAttribute('class', 'closeBtn');
      btn.innerHTML = me.getCloseBtnText(countdown, skip);
      me.setCloseBtnWidth(skip, btn);
      if (skip == 1) {
        btn.addEventListener('click', () => {
          util.stopPropagation();
          this.pauseFirstAdVideoByClassName('adVideo');
          common.triggerCloseBtnWithNoConfirmForSplash();
        });
      } else {
        // 防止点击后的冒泡触发背景的install事件
        btn.addEventListener('click', () => {
          util.stopPropagation();
        });
      }
      bg.insertAdjacentElement('beforeend', btn);

      // 预留事件，为SDK计时器更新剩余时间
      document.addEventListener('updateCountdown', function (values) {
        const btn = (document.getElementsByClassName('closeBtn'))[0];
        const secondRemain = parseInt(values.param.countdown, 10);
        if (secondRemain >= 0) {
          btn.innerHTML = me.getCloseBtnText(secondRemain, mainCampaign.unitSetting.allowSkip);
        }
        if (secondRemain <= 0) {
          this.pauseFirstAdVideoByClassName('adVideo');
          // 倒计时结束，触发关闭
          // common.triggerCloseBtnWithNoConfirmForSplash();
        }
      })
    } else {
      // 防止webview关闭后仍有声音的bug
      document.addEventListener('updateCountdown', function (values) {
        this.pauseFirstAdVideoByClassName('adVideo');
      })
      // 此处应SDK要求完全由SDK自行管理
      // common.toggleCloseBtnForSplash(1);
    }
  }

  /**
   * 通知 SDK 用户触发了点击安装事件, SDK 会在执行对应的跳转安装的同时上报业务 click
   */
  install () {
    // 假定 install 触发时的 this 对象一定是一个包含了 campaignId 属性的 DOM 对象,
    // 当前页面获取到的所有 campaign 会以 id 作为 key, 存储到一个 campaignMap 对象中,
    // install 触发时会从 campaignMap 中找到当前 campaignId 属性对应的 campaign, 丢给后续逻辑处理
    let defaultCampaign = {}
    let campaignId = document.body.getAttribute('campaignid');
    if (!campaignId) return
    defaultCampaign = Object.assign(defaultCampaign, mainCampaign.campaignList[0]);

    // 用于避免安卓参数过长被截断的问题
    if (util.device().isAndroid) {
      defaultCampaign = util.getParams2Native(defaultCampaign);
    }

    try {
      // click_url 替换
      let clickPosition = util.getMousePosition(event);
      let _data = mainCampaign;
      const _scale = _data.device.scale || window.devicePixelRatio;
      const cdnate_cfg = _data.appSetting.cdnate_cfg;
      let device_width = _data.device.screen_width;
      let device_height = _data.device.screen_height;

      clickPosition.x = clickPosition.x * _scale;
      clickPosition.y = clickPosition.y * _scale;

      if (util.device().isiOS) {
        device_width = _data.device.device_width * _scale;
        device_height = _data.device.device_height * _scale;
      }

      let click_url = defaultCampaign.click_url;
      let rel = /.+:\/\/(.*?)\//;
      let relhost = rel.exec(click_url)
      let host = relhost ? relhost[1] : '';
      let tar = {
        x: parseInt(clickPosition.x),
        y: parseInt(clickPosition.y),
        width: parseInt(device_width || window.screen.width),
        height: parseInt(device_height || window.screen.height)
      }

      if (cdnate_cfg && cdnate_cfg[host]) {
        let item = cdnate_cfg[host];
        for (let k in item) {
          let arr = item[k]
          for (let i = 0; i < arr.length; i++) {
            click_url = click_url.replace(new RegExp(arr[i], 'g'), tar[k])
          }
        }
      }

      defaultCampaign.click_url = click_url
      console.log('我是click_url: ', defaultCampaign.click_url)
    } catch (error) {
      console.log(error);
    }
    sendAdtracking(defaultCampaign.click_url);
    replaceAppFlyerHost(defaultCampaign);

    defaultCampaign = util.getParams2Native(defaultCampaign);

    console.log(`params: `, defaultCampaign);
    try {
      util.hybirdEvent({
        sClass: 'SplashJs',
        hybirdFn: 'install',
        params: defaultCampaign,
        succ: function (res) {
          //document.write(res);
        },
        err: function () {
          util.tips('Sorry, network error...');
        }
      })
    } catch (err) {
      console.log(err);
    }

    // 用于修复全屏可点功能开启时, 点击按钮会冒泡触发两次 install 的问题
    util.stopPropagation();
  }

  /**
   * IOS 控制下拉页面回弹
   */
  toggleBounces (cb) {
    util.hybirdEvent({
      hybirdFn: 'toggleBounces',
      params: {
        state: 0 // 关闭反弹
      },
      succ: function (res) {
        cb && cb(res)
      },
      err: function () {

      }
    })
  }

  // 上报相关 - START
  /**
   * pv链接上报
   * @description only_impression_url字符串 以及 pv_urls数组
   * @param {Object} bridgeContext init接口返回的信息
   */
  reportPv (bridgeContext) {
    let arr = [];
    let campaign = bridgeContext && bridgeContext.campaignList && bridgeContext.campaignList[0];
    arr.push({url: util.iosEnCodeURL(campaign['only_impression_url'])});
    arr.push({url: util.iosEnCodeURL(campaign['impression_url'])});
    console.log('要上报的 pv 相关 pv_urls: ', campaign && campaign.pv_urls)
    campaign && campaign.pv_urls && campaign.pv_urls.length && campaign.pv_urls.forEach((item) => {
      arr.push(util.iosEnCodeURL(item));
    })
    console.log('要上报的 pv 相关 ad_tracking.impression: ', campaign && campaign.ad_tracking && campaign.ad_tracking.impression)
    campaign && campaign.ad_tracking && campaign.ad_tracking.impression && campaign.ad_tracking.impression.forEach((item) => {
      arr.push(util.iosEnCodeURL(item));
    })
    console.log('要上报的 pv 相关 final: ', arr)
    common.reportUrls(arr, 'SplashJs');
  }

  /**
   * 上报Offer impression_url, 一个offer展示一次上报一次，每个offer只上报一次
   * @param {Object} bridgeContext init接口返回的信息
   */
  reportOfferImpression (bridgeContext) {
    let arr = [];
    bridgeContext.campaignList.forEach((offer) => {
      arr.push({
        type: offer['imp_ua'],
        url: util.iosEnCodeURL(offer['impression_url'])
      })
    })
    common.reportUrls(arr, 'SplashJs');
  }

  /**
   * 上报Offer ad_tracking.impression 一个offer展示一次上报一次，每个offer只上报一次
   * @param {Object} bridgeContext init接口返回的信息
   */
  reportAdTrackingImpression (bridgeContext) {
    let arr = [];
    bridgeContext.campaignList.forEach((offer) => {
      const adTrackingImpression = offer.ad_tracking;
      if (adTrackingImpression && Array.isArray(adTrackingImpression) && adTrackingImpression.length > 0) {
        adTrackingImpression.forEach((item) => {
          arr.push({
            url: util.iosEnCodeURL(item),
          })
        });
      } else if (adTrackingImpression && typeof adTrackingImpression) {
        arr.push({
          url: util.iosEnCodeURL(adTrackingImpression),
        });
      }
    })
    common.reportUrls(arr, 'SplashJs');
  }

  /**
   * 展示统计 (只有offer展示才上报), 向sdk传展示的offer全部信息,如campaignList[0]
   * @param {Object} bridgeContext campaign信息
   */
  reportCamId (bridgeContext) {
    common.sendImpressions(bridgeContext, 'SplashJs');
  }

  //上报相关 - END

  getAllSrcLocations (campaign, unitId) {
    //
    // let videoUrl = 'https://interactive-examples.mdn.mozilla.net/media/examples/flower.mp4';
    let videoUrl = campaign.video_url;
    let imageUrl = campaign.image_url;
    const resourceGroup = [];
    if (videoUrl) {
      resourceGroup.push({
        ref: videoUrl,
        type: 1,
      });
    }
    resourceGroup.push({
      ref: imageUrl,
      type: 4,
    });
    // Todo: 加入回调函数处理getFileInfo的返回值并赋值给srcLocations
    // 最后调用renderDOM()渲染页面
    common.getAllSrcLocations({
      resource: resourceGroup,
      unitId,
    }, 'SplashJs', getFileInfoRes => {
      console.log('getFileInfoRes: ', {getFileInfoRes})
      getFileInfoRes.resource.forEach(item => {
        let videoResource = item[videoUrl];
        let imageResource = item[imageUrl];
        if (videoResource && videoResource.type === 1) {
          campaign.video_url_localPath = videoResource.path4Web
        } else if (imageResource && imageResource.type === 4) {
          campaign.image_url_localPath = imageResource.path
        } else {
          console.warn('当前返回的资源不是 video/image 类型, 暂不处理', item)
        }
      })
    });
  }

  /**
   * 与SDK通信获取跳转链接、图片资源地址等信息
   */
  fetchMainData () {
    // 信息获取成功之后将触发‘getInfoSuccess’事件
    common.getInfoForSplash();
  }

  /**
   * 渲染页面
   */
  renderDOM () {
    const me = this;
    // 初始化Appflyer
    getAppFlyerRoute(mainCampaign.campaignList[0]);
    // 插入点击链接
    me.insertNoticeUrl();
    // 设置背景
    me.setBackground();
    // 前景图片/视频自适应
    me.mainContentAdaptingAndDisplay();
    // 关闭IOS页面回弹
    if (util.device().isiOS) {
      me.toggleBounces();
    }
    // 通告sdk准备完成
    common.isReadyStatusForSplash(1);
  }

  /**
   * 初始化函数
   */
  init () {
    this.fetchMainData();
  }
}

document.addEventListener('getInfoSuccess', function (res) {
  mainCampaign = res.param;
  app.getAllSrcLocations(mainCampaign.campaignList[0], mainCampaign.unitSetting.unitId);
})

document.addEventListener('webviewshow', function () {
  // 显示关闭按钮
  const btnType = util.getUrlParams('btnType') ? util.getUrlParams('btnType') : 0;
    app.toggleCloseBtn(btnType, mainCampaign.unitSetting.allowSkip, mainCampaign.unitSetting.countdown);

  // 播放视频，已兜底，无需单独验证video是否存在
  app.playFirstAdVideoByClassName('adVideo');

  // 上报 onlyImp, imp, ad_tracking.imp, pv_urls
  app.reportPv()
  // increaseOfferFrequence
  app.reportCamId()
})

window.onload = function () {
  if (!app) {
    app = new App();
    window.app = app;
    app.init();
  }
}


// WEBPACK FOOTER //
// ./src/rv/splash/entrys/splash/splash.js